<template>
    <div class="term">
        <span class="year">
        <input class="year" type="number" min=2010 max=2099 :value="year" @input="updateYear($event.target.value)">年
        <input class="year" type="number" min=1 max=12 :value="month" @input="updateMonth($event.target.value)">月
        16日〜</span>
        <div><button @click="generateTerm()">カレンダーを初期化</button></div>
    </div>
</template>


<script>
import Firebase from 'firebase';

export default {
    data() {
        let now = new Date();
        return {
            year: now.getFullYear(),
            month: now.getMonth() + 1,
        }
    },
    methods: {
        updateYear(year) {
            this.year = Math.floor(year);
        },
        updateMonth(month) {
            this.month = Math.floor(month);
        },
        generateTerm() {
            if(!confirm("カレンダーを初期化します。よろしいですか？")) {
               return;
            }
            let d = new Date(this.year, this.month - 1, 16);
            let days = [];
            for (;;) {
                let key = `${d.getFullYear()}-${('0' + d.getMonth()).slice(-2)}-${('0'+d.getDate()).slice(-2)}`
                let weekday = d.getDay();
                days[key] = {
                    year: d.getFullYear(),
                    month: d.getMonth() + 1,
                    day: d.getDate(),
                    minEditor: 1,
                    minReporter: (weekday == 0 || weekday == 6) ? 2 : 4,
                    maxReporter: (weekday == 0 || weekday == 6) ? 3 : 10,
                }
                d = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
                if (d.getDate() == 16) {
                    break;
                }
            }
            Firebase.database().ref(`/days`).set(days);
        },
    }
}
</script>


<style lang="scss" scoped>
.term {
    margin: 1em 0;
}
.year {
    text-align: right;
    font-size: xx-large;
    padding: 0.2em;
}
</style>



// WEBPACK FOOTER //
// src/TermBuilder.vue